import { Alert, CloseButton, Heading, IconBulb, Paragraph } from '@zillow/constellation';
import type { RentalApplication } from '../../../graphql/queries';
import {
  getIsApproved,
  getIsComplete,
  getIsDeclined,
  getIsViewedByLandlord,
  getIsWithdrawn,
} from '../../../utils/business-logic';

interface Props {
  application: RentalApplication;
}

export function ApplicationOverviewWhatsNext({ application }: Props) {
  const isComplete = getIsComplete(application);
  const isWithdrawn = getIsWithdrawn(application);
  const isViewedByLandlord = getIsViewedByLandlord(application);
  const isApproved = getIsApproved(application);
  const isDeclined = getIsDeclined(application);

  const canMessage = !!application.rentalListing;

  const showWhatsNext = isComplete && !(isViewedByLandlord || isApproved || isDeclined || isWithdrawn);

  return showWhatsNext && <WhatsNextAlert canMessage={canMessage} />;
}

export function WhatsNextAlert({ canMessage }: { canMessage: boolean }) {
  return (
    <Alert
      appearance="info"
      icon={<IconBulb />}
      body={
        <>
          <Heading level="6" as="h2">
            You’ll get an email when your application is seen
          </Heading>
          <Paragraph marginTop="sm">
            When the landlord or property manager opens your application, you’ll get an email notification. If they need
            more information, they may contact you by email or phone.
            {canMessage ? ' You can contact them using the message link on this page.' : ''}
          </Paragraph>
        </>
      }
      marginBottom="sm"
      closeButton={<CloseButton />}
    />
  );
}
